import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    '& > div:first-child, & > div:last-child': {
      padding: '2em 0',
      width: 'calc(50% - 80px)',
    },
    '& > div:first-child': {
      paddingRight: '1em',
    },
    '& > div:last-child': {
      paddingLeft: '1em',
    },
    '& > div:nth-child(2)': {
      width: '160px',
      textAlign: 'center',
      padding: '2em 0',
    },
  },
  remarks: {
    fontSize: '0.750em',
    margin: '0',
    '&:not(:last-child)': {
      marginBottom: '0.25em',
    },
  },
  paymentLabel: {
    margin: '0 0 0.75em',
    fontSize: '1em',
  },
  paymentType: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '0.875em',
    '& > span': {
      display: 'inline-block',
      width: '18px',
      height: '18px',
      borderRadius: '18px',
      border: `1px solid ${theme.custom.teal}`,
      marginRight: '5px',
    },
    '& > span::before': {
      content: '""',
      display: 'block',
      width: '16px',
      height: '16px',
      borderRadius: '16px',
      border: `1.5px solid ${theme.custom.white}`,
      backgroundColor: theme.custom.teal,
    },
  },
  lineItem: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1em',
    '& p': {
      fontSize: '0.875em',
      margin: '0',
    },
    '& p:first-child': {
      width: 'calc(100% - 90px)',
    },
  },
  divider: {
    border: 'none',
    borderBottom: `1px solid ${theme.custom.gray300}`,
    margin: '0 0 1em',
  },
}));

const Footer = () => {
  const classes = useStyles();

  return (
    <footer className={classes.wrapper}>
      <div>
        <p className={classes.remarks}>
          <u>Validation of brand certificates</u>
        </p>
        <p className={classes.remarks}>
          Brand inspection certificates, except for “Change of ownership”
          and “Travel permits” shall be automatically cancelled and void
          one week after time of issuance. This is certificate void if
          altered.
        </p>
      </div>
      <div>
        <p className={classes.paymentLabel}>Payment by</p>
        <label className={classes.paymentType}>
          <span />
          Check
        </label>
      </div>
      <div>
        <div className={classes.lineItem}>
          <p>Beef Council</p>
          <p>$64.00</p>
        </div>
        <div className={classes.lineItem}>
          <p>Predator Patrol</p>
          <p>$123.00</p>
        </div>
        <div className={classes.lineItem}>
          <p>Brand Inspection Fee Subtotal</p>
          <p>$187.00</p>
        </div>
        <hr className={classes.divider} />
        <div className={classes.lineItem}>
          <p>Total Fee Charges</p>
          <p>$261.00</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
